import ResearchCardCommon from './containers/researchCardCommon'

export {default as ResearchCardCommonLayout} from './components/researchCardCommonLayout'

export default ResearchCardCommon
